const DURATION = 5000;
const FADE = 1000;

export function initPhotoFaders(): void {
    const faders = document.querySelectorAll<HTMLElement>('[data-swl-photo-fader]');

    faders.forEach(fader => {
        const images = Array.from(fader.querySelectorAll<HTMLElement>('img'));

        if (images.length <= 1) {
            images[0]?.classList.add('is-active');

            return;
        }

        let current = 0;
        images.forEach((image, index) => image.classList.toggle('is-active', index === 0));

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            return;
        }

        const advance = (): void => {
            images[current].classList.remove('is-active');
            current = (current + 1) % images.length;
            images[current].classList.add('is-active');
        };

        // Self-scheduling setTimeout instead of a fire-and-forget setInterval, with the
        // swap wrapped in requestAnimationFrame: rAF is paused while the tab is in the
        // background, so hidden tabs neither animate nor pile up swaps, and the chain
        // stays a single pending timer per fader.
        const scheduleNext = (): void => {
            window.setTimeout(() => {
                requestAnimationFrame(() => {
                    advance();
                    scheduleNext();
                });
            }, DURATION + FADE);
        };

        scheduleNext();
    });
}
